var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5C0 7.835 7.835 0 17.5 0S35 7.835 35 17.5 27.165 35 17.5 35 0 27.165 0 17.5z",
    fill: "#0077B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.367 14.494V26.41H8.401V14.494h3.966zm.261-3.686c0 1.144-.861 2.06-2.244 2.06h-.025c-1.332 0-2.192-.916-2.192-2.06 0-1.168.887-2.058 2.243-2.058 1.357 0 2.193.89 2.218 2.058zm14.042 8.77v6.832h-3.966v-6.375c0-1.601-.574-2.694-2.01-2.694-1.096 0-1.748.737-2.035 1.448-.105.255-.13.61-.13.967v6.654h-3.967s.053-10.797 0-11.915h3.967v1.687c.526-.811 1.469-1.968 3.574-1.968 2.61 0 4.567 1.704 4.567 5.364z",
    fill: "#FFF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinAlt);
export default __webpack_public_path__ + "static/media/linkedin-alt.7562e9fce433e5595efe59b5d70e0795.svg";
export { ForwardRef as ReactComponent };